import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DistrictModel, UserModuleApiSuffixModels, loggedInUserData } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudService, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, formConfigs, prepareGetRequestHttpParams, setRequiredValidator } from '@app/shared';
import { UserLogin } from '@modules/others/models';
import { Store, select } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-district-add-edit',
  templateUrl: './district-add-edit.component.html',
})

export class DistrictAddEditComponent implements OnInit {
  formConfigs = formConfigs;
  districtAddEditForm: FormGroup;
  loggedUser: UserLogin;
  regionList: any;
  divisionDropDown: any = []
  districtModel: DistrictModel;

  constructor(public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private crudService: CrudService, private formBuilder: FormBuilder,
    private store: Store<AppState>, private rxjsService: RxjsService) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
    this.districtModel = this.config.data
  }

  ngOnInit(): void {
    this.rxjsService.setDialogOpenProperty(true);
    this.createDivisionForm();
    this.getRegions();
    this.onFormControlChanges();
    this.getDetailsById();
  }

  getDetailsById() {
    let _ids = []
    for (const iterator of this.districtModel?.divisionId.split(',')) {
      _ids.push(iterator.toLowerCase())
    }
    this.districtModel.divisionId = _ids;

    this.districtModel.userId = this.loggedUser.userId
    this.districtAddEditForm.patchValue(this.districtModel);

  }

  onFormControlChanges(): void {
    this.districtAddEditForm.get('regionId').valueChanges.subscribe((regionId: string) => {
      if (!regionId) return;
      this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_DIVISIONS, null, false,
        prepareGetRequestHttpParams(null, null,
          { regionId: regionId }))
        .subscribe((response: IApplicationResponse) => {
          if (response && response.resources && response.isSuccess) {
            this.divisionDropDown = response.resources;
          }
          if (this.districtModel.districtId && (this.districtModel.regionId == this.districtAddEditForm.get("regionId").value)) {
            this.districtAddEditForm.get('divisionId').setValue(this.districtModel.divisionId)
          } else {
            this.districtAddEditForm.get('divisionId').setValue([])
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        })
    });
  }

  regionChange() {
    this.districtAddEditForm.controls.divisionId.setValue([]);
  }

  getRegions() {
    this.crudService.dropdown(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_REGIONS,
      prepareGetRequestHttpParams(null, null,
        { CountryId: formConfigs.countryId })).subscribe((response) => {
          if (response.statusCode == 200) {
            this.regionList = response.resources;
          }
          let found = this.regionList.filter(e => e.id == this.districtModel.regionId)
          if (found.length == 0) {
            this.districtAddEditForm.controls.regionId.setValue('');
          }
        });
  }

  createDivisionForm(): void {
    let districtModel = new DistrictModel();
    this.districtAddEditForm = this.formBuilder.group({});
    Object.keys(districtModel).forEach((key) => {
      this.districtAddEditForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId' || key == 'userId') ? new FormControl(this.loggedUser.userId) :
        new FormControl(districtModel[key]));
    });
    this.districtAddEditForm = setRequiredValidator(this.districtAddEditForm, ["regionId", "divisionId", "districtName"]);
  }

  onSubmit(): void {
    if (this.districtAddEditForm.invalid) return;
    let formData = this.districtAddEditForm.value;
    if (Array.isArray(formData.divisionId) && formData.divisionId.length > 0) {
      formData.divisionId = formData.divisionId.toString()
    }
    let crudService: Observable<IApplicationResponse> = !this.districtAddEditForm.value.districtId ? this.crudService.create(ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.DIVISION_DISTRICT, this.districtAddEditForm.value) :
      this.crudService.create(ModulesBasedApiSuffix.IT_MANAGEMENT,
        UserModuleApiSuffixModels.DIVISION_DISTRICT, this.districtAddEditForm.value);
    crudService.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.ref.close(false)
        this.districtAddEditForm.reset();
      }
    });
  }

  dialogClose(): void {
    this.ref.close(true);
  }

  ngOnDestroy(): void {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
